'use strict';

angular.module('MrDWebApp').controller('PayuCtrl', function ($scope, $q, $window, $http) {

  const _payu = this;

  _payu.loading = false;
  _payu.invalid = true;
  _payu.fieldsValid = {
    pan: false,
    expiry: false,
    cvv: false,
  };

  _payu.feedback = {
    success: false,
    error: false,
    message: '',
  };

	_payu.form = {};

	_payu.formChange = function () {
		if (_payu.form.holder_name) _payu.form.holder_name = _payu.form.holder_name.replace(/[!@#$%&*()+={[}\]:;<,>\?\/"]/, '');
		if (_payu.form.card_nickname) _payu.form.card_nickname = _payu.form.card_nickname.replace(/[!@#$%&*()+={[}\]:;<,>\?\/"]/, '');
	};

  /*
    Create an instance of the secure fields. Pass the public key as the first argument.
    As the second argument, we'll pass a list of custom fonts to be applied to the fields (this is optional).
  */
  const formElements = new $window.POS.Fields(window.env.payuPK);

  const style = {
    base: {
      color: '#131313',
      fontWeight: 600,
      fontFamily: 'Quicksand, Open Sans, Segoe UI, sans-serif',
      fontSize: '16px',
      fontSmoothing: 'antialiased',
      ':focus': {
        color: '#424770',
      },

      '::placeholder': {
        color: '#9BACC800',
      },

      ':focus::placeholder': {
        color: '#CFD7DF',
      },
    },
    invalid: {
      color: '#FF0000',
      ':focus': {
        color: '#FA755A',
      },
      '::placeholder': {
        color: '#FFCCA5',
      },
    }
  };


  /*
    Create an object holding additional options that you can pass to the constructor for instantiating
    the credit card and card expiry fields.
    There are lots of other options available that you can pass to the constructor,
    but to keep it simple we'll just show this one object in our example.
  */
  const placeholders = {
    cardNumber: '1234 1234 1234 1234',
    expDate: 'MM / YY'
  };

  // Instantiate the fields you want to show and mount them to the DOM.
  const cardNumber = formElements.create('cardNumber', { placeholders, style });
  cardNumber.mount('#card-number');

  const expiry = formElements.create('creditCardExpiry', { placeholders, style });
  expiry.mount('#exp-date');

  const cvv = formElements.create('cvv', { placeholders, style });
  cvv.mount('#cvv');

  const callback = function (field) {
    return function (payload) {
      $scope.$apply(function () {
        _payu.fieldsValid[field] = payload.error === undefined && payload.complete;
        _payu.invalid = !_payu.fieldsValid.pan || !_payu.fieldsValid.expiry || !_payu.fieldsValid.cvv;
      });
    };
  };

  cardNumber.on('change', callback('pan'));
  expiry.on('change', callback('expiry'));
  cvv.on('change', callback('cvv'));

  _payu.saveCard = function() {

    _payu.loading = true; // spinner on save button

    let token = $window.POS.createToken(cardNumber, {
      additionalData: {
        holder_name: _payu.form.holder_name, // This field is mandatory
      },
      environment: window.env.payuEnv // Set the PaymentsOS environment you're connecting to
    }).then(function successCallback(response) {

      // error from token call (success is a string)
      if (typeof response !== 'string') {
        console.log('Error processing form data', response.error);
        return {
          success: false,
          error: true,
          message: response.error[Object.keys(response.error)[0]]
        };
      }

      if (JSON.parse(response).description) return {
        success: false,
        error: true,
        message: JSON.parse(response).description
      };

      try {
        return $http.post(window.env.caApiURL + 'restaurant/secure_fields_form_submit', {
          response: JSON.parse(response),
          saved_card: {
            label: _payu.form.card_nickname,
            is_default: _payu.form.is_default,
          }
        }, { bypassErrorHandler: true })
          .then(function successCallback(response) {
            console.log('Card added', response);
            return {
              success: true,
              error: false,
              message: 'Card added!'
            };
          }, function errorCallback(response) {
            console.log('Error adding card', response);
            if (response.data) return {
              success: false,
              error: true,
              message: response.data.error.title + '. ' + response.data.error.friendly_message
            };
            return {
              success: false,
              error: true,
              message: 'We have an issue adding your card right now. Please try again later.'
            };
          });
      } catch (error) {
        console.log('Error adding card', error);
        return {
          success: false,
          error: true,
          message: error
        };
      }
    }, function errorCallback(response) {
      console.log('Error tokenizing card', response);
      return {
        success: false,
        error: true,
        message: response.error[Object.keys(response.error)[0]]
      };
    });

    $q.resolve(token).then(function (result) {
      _payu.feedback = result;
      _payu.loading = false;
      if (result.success) {
        $scope._rc.showCards(null, 'all');
        $scope._checkout.loadCards();
      }
    });

  };

});
